import { TOfferCategory } from '../../../../types/offer';
import { getRentPrice } from './getRentPrice';

export interface IGetRentPriceParams {
  priceRur: number;
  category: TOfferCategory | null;
  utilitiesPriceRur: number;
}

export function getRentPriceWithUtilities({ utilitiesPriceRur, category, priceRur }: IGetRentPriceParams): string {
  let price = priceRur;

  price += utilitiesPriceRur;

  return getRentPrice({ priceRur: price, category });
}
